import Immutable from 'immutable';

function keyIn(/*...keys*/) {
  var keySet = Immutable.Set(arguments);
  return function (v, k) {
    return keySet.has(k);
  };
}

export default keyIn;
